import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import LayoutProvider from '../../context/LayoutProvider/LayoutProvider';
import { useData } from '../../context/DataProvider/DataProvider';
import { useLanguage } from '../../context/LanguageProvider/LanguageProvider';

import { App, NioStickyBadge } from '../../components';
import Header from '../../components/Header';
import NioBackTop from '../../components/NioBackTop/NioBackTop';

/**
 * Auth pages with the same top navbar as the rest of the site (navigation.two when not on /).
 * @param {number} headerVariant — layout-config variant (13 = data-driven / JASSP header style).
 */
function AuthLayout({
  title = 'Page Title Goes Here',
  titleKey,
  rootClass = 'layout-1',
  children,
  headerVariant = 13,
}) {
  const data = useData();
  const location = useLocation();
  const { t } = useLanguage();
  const navigation = data.navigation;
  const headerData = location.pathname === '/' ? navigation.one : navigation.two;

  const resolvedTitle = titleKey ? t(titleKey) : title;

  useEffect(() => {
    document.title = `${resolvedTitle} - ${t('layout.docSuffix')}`;
  }, [resolvedTitle, t]);

  return (
    <LayoutProvider>
      <App rootClass={rootClass}>
        <Header variant={headerVariant} data={headerData} />
        <App.Main>
          <div className="nk-split-page jassp-auth-shell flex-column flex-xl-row">
            <div className="nk-split-col nk-auth-col justify-content-center w-100">
              {children}
            </div>
          </div>
        </App.Main>
        <NioBackTop />
        <NioStickyBadge />
      </App>
    </LayoutProvider>
  );
}

export default AuthLayout;
